import {
  APP_FETCH_ERROR,
  APP_FETCH_STARTED,
  APP_FETCH_SUCCESS,
  CLOSE_PASSWORD_MODAL,
  MFA_SUBMIT_CODE,
  MFA_SUBMIT_EMAIL,
  OPEN_PASSWORD_MODAL,
  POP_NOTIFICATION,
  PUSH_NOTIFICATION,
} from '../../constants';

export const isFetching = (statusKey) => ({
  type: 'APP',
  cmd: APP_FETCH_STARTED,
  payload: statusKey,
});

export const successFetch = (statusKey) => ({
  type: 'APP',
  cmd: APP_FETCH_SUCCESS,
  payload: statusKey,
});

export const errorFetch = (statusKey, error) => ({
  type: 'APP',
  cmd: APP_FETCH_ERROR,
  payload: { error, statusKey },
});

export const openPasswordModal = () => ({
  type: OPEN_PASSWORD_MODAL,
  cmd: OPEN_PASSWORD_MODAL,
});

export const closePasswordModal = () => ({
  type: CLOSE_PASSWORD_MODAL,
  cmd: CLOSE_PASSWORD_MODAL,
});

// MFA ////////////////////////////////////////////////////////////////////////
export const MFASubmitEmail = (email) => ({
  type: MFA_SUBMIT_EMAIL,
  cmd: MFA_SUBMIT_EMAIL,
  payload: { email },
  remote: true,
  status: 'mfa',
});

export const MFASubmitCode = (code, email) => ({
  type: MFA_SUBMIT_CODE,
  cmd: MFA_SUBMIT_CODE,
  payload: { code, email },
  remote: true,
  status: 'mfa',
});

// Notifications //////////////////////////////////////////////////////////////
export const pushMessage = (msg) => ({
  type: PUSH_NOTIFICATION,
  cmd: PUSH_NOTIFICATION,
  payload: msg,
});

export const popMessage = (msg) => ({
  type: POP_NOTIFICATION,
  cmd: POP_NOTIFICATION,
});

// Cookie Check ///////////////////////////////////////////////////////////////
export const cookieStatus = (isEnabled = false) => ({
  type: 'COOKIE_STATUS',
  cmd: 'COOKIE_STATUS',
  payload: {
    status: isEnabled ? 'PASS' : 'ERROR',
    error: !isEnabled,
  },
});
